import type { HistoryRepositoryState } from "./types";
import { withState } from "../../Repository";

export const makeState: () => HistoryRepositoryState = withState<HistoryRepositoryState>({
    data: []
});
